import { render, staticRenderFns } from "./printer-list.vue?vue&type=template&id=be37eed4&scoped=true&"
import script from "./printer-list.vue?vue&type=script&lang=js&"
export * from "./printer-list.vue?vue&type=script&lang=js&"
import style0 from "./printer-list.vue?vue&type=style&index=0&id=be37eed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be37eed4",
  null
  
)

export default component.exports